export default "__VITE_ASSET__BAI3k9$W__"